import { Component, Input, OnInit } from '@angular/core';
import { DonutChartComponent } from '../../../../../shared/components/donut-chart/donut-chart.component';
import { IFundPortfolioChart, IFundPortfolioGoldChart } from '../../../models/fund-chart.model';
import { IFundProfileModel } from '../../../models/fund-profile.model';

@Component({
  selector: 'app-assets-composition-chart',
  standalone: true,
  imports: [DonutChartComponent],
  templateUrl: './assets-composition-chart.component.html',
  styleUrl: './assets-composition-chart.component.scss',
})
export class AssetsCompositionChartComponent implements OnInit {
  @Input() data: IFundPortfolioChart & Partial<IFundPortfolioGoldChart>;
  @Input() type?: IFundProfileModel['type'];
  labels: string[] = [];
  chartData: number[] = [];
  preferredColors: string[] | null = null;

  ngOnInit(): void {
    for (const [key, value] of Object.entries(this.data)) {
      if (key !== 'date' && value) {
        this.labels.push(key);
        this.chartData.push(value);
      }
    }
    this.type === 'Gold' ? (this.preferredColors = ['#ff981a', '#fbc972']) : null;
  }
}
